import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("rect", {
      width: "24",
      height: "24",
      fill: "#fff",
      rx: "12",
      style: {"fill":"#fff","fill-opacity":"1"}
    }, null, -1),
    _createElementVNode("path", {
      fill: "#0F1729",
      "fill-rule": "evenodd",
      d: "M16.828 9.177c.23.236.23.618 0 .854l-5.467 5.615a1.155 1.155 0 0 1-1.663 0l-2.526-2.594a.616.616 0 0 1 0-.854.577.577 0 0 1 .832 0l2.525 2.594 5.467-5.615a.577.577 0 0 1 .832 0",
      "clip-rule": "evenodd",
      style: {"fill":"color(display-p3 .0588 .0902 .1608)","fill-opacity":"1"}
    }, null, -1)
  ])))
}
export default { render: render }